import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MaillotCommande } from '../account.dto';

@Component({
  selector: 'app-account-orders-sheet',
  templateUrl: './account-orders-sheet.component.html',
  styleUrls: ['./account-orders-sheet.component.scss']
})
export class AccountOrdersSheetComponent {
  commandes: MaillotCommande[];

  constructor(
    private bottomSheetRef: MatBottomSheetRef<AccountOrdersSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { commandes: MaillotCommande[] },
  ) {
    this.commandes = data.commandes;
  }

  close() { this.bottomSheetRef.dismiss(); }

  isDelivery(value: string): boolean {
    return value !== 'Retrait boutique';
  }
}
